// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__aLJuP","time":"styles_time__l8isg","noActive":"styles_noActive__Bpd+4","back":"styles_back__cYPEo","active":"styles_active__OefIE","next":"styles_next__jnDH6"};